import { ServerConfig } from "@/config/config";
import { createSocketService } from "@/utils/services/socket-service-factory";

export const AuthSocketService = createSocketService(ServerConfig.authSocket, "/socket.io/client/");